import type { Resource } from '../../';
export const country_search_title: Resource = {"default":"Search for a country."};
